module.exports = __webpack_public_path__ + "static/media/bg-1.684caf49.png";